import * as React from 'react';
import { GoCheck, GoX } from 'react-icons/go';
import { ExpandableTable } from '@quid/react-expandable-table';

import '@quid/theme/fonts/icons/index.css';
import { StyledCard, ExpandedRowContent, PerformanceSummary } from './AttemptPerformance.styles';


interface IProps {
  data?: any;
  selectedAttempt?: string;
}

interface IState {
  openedRows?: any;
}

const Content = (props) => {
  const { question, answer, final_score, max_score } = props.data;

  return (
    <ExpandedRowContent>
      <h4>Q: {question}</h4>
      {answer
        ? <p>Your Answer: {answer}</p>
        : <p>Your Score: {`${(final_score / max_score * 100).toFixed()}%`}</p>}
    </ExpandedRowContent>
  );
}

class AttemptPerformance extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      openedRows: ['1'],
    };

    this.onToggleRow = this.onToggleRow.bind(this);
  }

  public onToggleRow(openedRows) {
    this.setState({ openedRows });
  }

  public convertTimeTaken = (value) => {
    const sec = parseInt(value, 10); // convert value to number if it's string
    const hrs   = Math.floor(sec / 3600); // get hours
    const mins = Math.floor((sec - (hrs * 3600)) / 60); // get minutes
    let secs = String(sec - (hrs * 3600) - (mins * 60)); // get seconds

    if (Number(secs) < 10) { secs = `0${secs}`; }

    return `${hrs > 0 ? hrs + 'h' : ''} ${mins > 0 ? mins + 'm' : ''} ${Number(secs) > 0 ? secs + 's' : ''}`;
  }

  public render() {
    const { openedRows } = this.state;
    const { data, selectedAttempt } = this.props;
    const attempt = data.Attempts[Number(selectedAttempt)];
    const tableData = attempt.Performance.map((row, i) => {
      return {
        ...row,
        time_taken: this.convertTimeTaken(row.time_taken),
        question_identifier: `${i + 1}. ${row.type}`,
        correct: (row.final_score/row.max_score) >= 0.5 ? <GoCheck size="32px" color="#b5f92d" /> : <GoX size="32px" color="#ff0033" />,
      }
    });
    const columns = [
      {
        label: 'Question',
        key: 'question_identifier',
      },
      {
        label: 'Question Type',
        key: 'type',
        align: 'center',
      },
      {
        label: 'Correct',
        key: 'correct',
        align: 'center',
      },
      {
        label: 'Time Taken',
        key: 'time_taken',
        tooltip: 'Time taken to complete a question',
        align: 'center',
      },
    ];

    if (!selectedAttempt || tableData.length === 0) { return null; }

    return (
      <StyledCard hidePatternBg={true}>
        <h2 className="title">{attempt.AttemptIdentifier} Performance</h2>
        <PerformanceSummary>
          <div>
            <h3>Attempt</h3>
            <p>{attempt.AttemptIdentifier}</p>
          </div>
          <div>
            <h3>Completion</h3>
            <p>{attempt.Completion}%</p>
          </div>
          <div>
            <h3>Correct Answers</h3>
            <p>{attempt.Performance.filter(perf => (perf.final_score / perf.max_score) >= 0.5).length}</p>
          </div>
          <div>
            <h3>Score</h3>
            <p>{attempt.Score ? `${attempt.Score}%` : '-'}</p>
          </div>
          <div>
            <h3>TIme Taken</h3>
            <p>{this.convertTimeTaken(attempt.TimeTakenSeconds || 0)}</p>
          </div>
        </PerformanceSummary>
        <ExpandableTable
          onToggle={this.onToggleRow}
          maxOpen={3}
          openedRows={openedRows}
          maxBodyHeight={300}
          renderRow={Content}
          columns={columns}
          data={tableData}
          className="expandable-table"
        />
      </StyledCard>
    );
  }
}

export default AttemptPerformance;



// WEBPACK FOOTER //
// ./src/components/DataCentre/AttemptPerformance/AttemptPerformance.tsx